var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertHydrant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M32 61.6C47.9058 61.6 60.8 48.7058 60.8 32.8C60.8 16.8942 47.9058 4 32 4C16.0942 4 3.20001 16.8942 3.20001 32.8C3.20001 48.7058 16.0942 61.6 32 61.6Z",
    stroke: "#C12010",
    strokeWidth: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M32 20.6095V34.3238",
    stroke: "#C12010",
    strokeWidth: 5.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M32 43.4667V44.8",
    stroke: "#C12010",
    strokeWidth: 5.33333,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertHydrant);
export default __webpack_public_path__ + "static/media/alert-hydrant.88f64c720b0973a5b04a2f2db6e32f6f.svg";
export { ForwardRef as ReactComponent };